import { Stack } from '@mui/material';
import { FC, useMemo, useState } from 'react';
import ScrollBox from '@/components/scroll-box';
import SearchInput from '@/components/search-input';
import useUserSettings from '@/hooks/use-user-settings.hook';
import UserSettingsCard from './card';
import { sortBy } from 'lodash';
import CardOpt from './card-opt';
import CardDetail from './card-detail';

interface Props {
  max: number;
}

const PrivateModelCard: FC<Props> = ({ max }) => {
  const [keyword, setKeyword] = useState('');
  const { isLoading, defaultAgent, privateModelSettings, threadSettings, setPrivateModelId } =
    useUserSettings();
  const availableModels = privateModelSettings.availablePrivateModels;
  const { privateModelId } = threadSettings;

  const filteredModels = useMemo(() => {
    const safeKeyword = String(keyword).trim().toLowerCase();
    return sortBy(availableModels || [], 'name').filter(({ name }) => {
      return String(name).toLowerCase().includes(safeKeyword);
    });
  }, [availableModels, keyword]);

  const hasModels = !!filteredModels.length;
  const showEmptyMessage = !isLoading && !hasModels;
  const emptyMessage = keyword ? 'No models found' : 'No models available';

  return (
    <UserSettingsCard title={defaultAgent.badgeTitle} loading={isLoading}>
      <CardDetail>Choose the model to use with the {defaultAgent.label}.</CardDetail>

      <Stack direction="row" justifyContent="space-between" alignItems="center" className="toolbar">
        <SearchInput
          value={keyword}
          onChange={setKeyword}
          placeholder="Search by name"
          disableHideInput
        />
      </Stack>

      <ScrollBox
        max={max}
        emptyMessage={showEmptyMessage ? emptyMessage : ''}
        selected={privateModelId}
      >
        {filteredModels.map((model) => {
          const { id, name } = model;
          const selected = id === privateModelId;
          return (
            <CardOpt
              name={name}
              id={id}
              selected={selected}
              onChange={setPrivateModelId}
              key={id}
            />
          );
        })}
      </ScrollBox>
    </UserSettingsCard>
  );
};

export default PrivateModelCard;
